export function useHeaderZIndex() {
  const header = document.querySelector('.site-header') as HTMLElement;

  const decreaseZIndex = () => {
    if (!header) {
      return;
    }
    header.style.zIndex = '1';
  };

  const increaseZIndex = () => {
    if (!header) {
      return;
    }
    header.style.zIndex = '1000';
  };

  return {
    decreaseZIndex,
    increaseZIndex,
  };
}
